import * as React from 'react';
import { StateFilter } from '../../../../../../Machine';
import { Suspended } from '../../../../../../Suspended';
import { LazyInvestmentGoalsQuestionnaireStep } from '../../../questionnaires/InvestmentGoalsQuestionnaire';
import { StepContainer } from '../../../utils/Step';
import { CommonInvestmentGoalsExclusions } from '../../shared';
import { ConseilInvestmentGoalsExclusion } from './exclusions';
import { BackToServiceSelection } from '../../../directNavigation/backToServiceSelection';

export const ConseilInvestmentGoals = () => (
  <>
    <StateFilter is=".questions">
      <Suspended>
        <LazyInvestmentGoalsQuestionnaireStep />
      </Suspended>
    </StateFilter>
    <StateFilter is=".exclusions">
      <StepContainer>
        <CommonInvestmentGoalsExclusions />
        <ConseilInvestmentGoalsExclusion />
        <BackToServiceSelection />
      </StepContainer>
    </StateFilter>
  </>
);
